<template>
    <div class="tab-pane active">
        <div class="row p-20">
            <div class="col-md-12 m_md_bottom_15">
                <router-link :to="{ name: 'deals.show.quotations.create', params: { id: deal.id } }" class="btn btn-default" v-if="deal.editable">
                    <span class="btn-label">
                        <i class="fa fa-plus-circle"></i>
                    </span>
                    {{ $t('quotation') }}
                </router-link>
                <span class="pull-right m-t-10">{{ $t('data_grid_entries_showing', [list.length]) }}</span>
            </div>
        </div>
        <div class="over_auto" v-pml-block="isFetching">
            <table class="table table-striped table-bordered m-0">
                <thead>
                    <tr>
                        <th class="t_center th_sort w_100" @click.prevent="setOrder('number')" :class="isOrderedColumn('number')">N&ordm;</th>
                        <th class="t_center th_sort w_120" @click.prevent="setOrder('issue_date_at')" :class="isOrderedColumn('issue_date_at')">{{ $t('issue_date') }}</th>
                        <th class="t_center th_sort w_120" @click.prevent="setOrder('exchange_rate')" :class="isOrderedColumn('exchange_rate')">{{ $t('ex_rate') }}</th>
                        <th class="t_center th_sort w_120" @click.prevent="setOrder('status')" :class="isOrderedColumn('status')">{{ $t('status') }}</th>
                        <th class="t_center th_sort">{{ $t('value') }}</th>
                        <th class="t_center w_180">{{ $t('actions') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <PmlItem v-for="item in list" :key="item.id" :item="item"></PmlItem>
                    <tr v-show="!list.length">
                        <td class="t_center" colspan="6"><i class="fa fa-exclamation-triangle"></i> {{ $t('no_records_found') }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import TableFilters from 'utils/mixins/table-filters'
    import PmlItem from './Item.vue'
    import { mapGetters } from 'vuex'

    export default {
        name: 'Quotations',
        mixins: [ TableFilters ],
        components: { PmlItem },
        data () {
            return {
                isFetching: false,
                listConfig: {
                    orderDir: 'desc',
                    orderProp: 'due_date_at'
                }
            }
        },
        computed: {
            ...mapGetters({
                'deal': 'getDealInfo',
                'quotations': 'getDealQuotations'
            }),
            records () {
                return this.quotations || []
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/deals/components/show/quotations/Main.vue